module.exports = __webpack_public_path__ + "static/media/auth-healtheat.4ce17c28.png";